// Tasks vocabulary (PROMPT 12)
import { SERVICE_LANES } from "@/config/resources";
export { TONE, optOf, labelOf, toneOf, prettify } from "@/config/tone";
export { SERVICE_LANES };

export const TASK_STATUSES = [
  { value: "not_started", label: "Not started", tone: "gray" },
  { value: "in_progress", label: "In progress", tone: "sky" },
  { value: "waiting_family", label: "Waiting on family", tone: "amber" },
  { value: "waiting_partner", label: "Waiting on partner", tone: "amber" },
  { value: "waiting_document", label: "Waiting on document", tone: "amber" },
  { value: "completed", label: "Completed", tone: "green" },
  { value: "cancelled", label: "Cancelled", tone: "gray" },
];

export const TASK_PRIORITIES = [
  { value: "urgent", label: "Urgent", tone: "red" },
  { value: "high", label: "High", tone: "amber" },
  { value: "normal", label: "Normal", tone: "navy" },
  { value: "low", label: "Low", tone: "gray" },
];

export const TASK_RELATED_TYPES = [
  { value: "leads", label: "Lead" },
  { value: "cases", label: "Family case" },
  { value: "partners", label: "Partner" },
  { value: "consultations", label: "Consultation" },
  { value: "properties", label: "Property" },
];
